
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['on-accept', 'on-cancel'],
  props: {
    isShared: { type: Boolean, default: false },
  },
});
